export default "__VITE_ASSET__B7fVu6Jg__"